module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sd-pagination"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showPrev) ? _c('a', {
    staticClass: "sd-pagi-button sd-prev",
    on: {
      "click": function($event) {
        _vm.previous()
      }
    }
  }, [_c('img', {
    class: {
      'sd-pulse': (_vm.loader && _vm.isPrev)
    },
    attrs: {
      "src": "/static/material_icons/arrow_left_white.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Vorherige")])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showNext) ? _c('a', {
    staticClass: "sd-pagi-button sd-next",
    on: {
      "click": function($event) {
        _vm.next()
      }
    }
  }, [_c('span', [_vm._v("Nächste")]), _vm._v(" "), _c('img', {
    class: {
      'sd-pulse': (_vm.loader && _vm.isNext)
    },
    attrs: {
      "src": "/static/material_icons/arrow_right_white.png"
    }
  })]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a63b858e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pagination.vue
// module id = 434
// module chunks = 1